export const root =  (typeof self === 'object' && self.self === self && self) ||
    (typeof global === 'object' && global.global === global && global) ||
    this;
export const doc = root?.document || {};
export const localStore = root?.localStorage || { getItem: () => "{}", setItem: console.log};